import React from 'react';
import { FormControlLabel } from '@material-ui/core';
import BaseRadio from '@material-ui/core/Radio';
import { useTranslation } from 'react-i18next';

import { RADIO_COLOR } from '../../enum/formProps';
import './Radio.scss';

interface RadioProps {
  label: string;
  value: string;
  color: RADIO_COLOR;
}

const Radio: React.FC<RadioProps> = (props) => {
  const { t } = useTranslation();

  return (
    <FormControlLabel
      className="Radio-FormControlLabel"
      value={props.value}
      label={t(props.label)}
      control={<BaseRadio color={props.color} />}
    />
  );
};

export default Radio;
